import axios from 'axios'
import router from '../router'

const APIService = axios.create({
  baseURL: process.env.VUE_APP_API_URL + '/user/',
})

APIService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('UserJWT')
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

APIService.interceptors.response.use(
  (response) => {

    if (response.data && response.data.Message === 'NOT_LOGIN') {
      console.warn('消費者尚未登入！')

      const { name: routeName, path: routePath } = router.currentRoute.value
      /* 以 name + path 雙檢，避免懶加載期間 name 尚未就緒被誤導回首頁 */
      const allowWithoutLogin = ['Home', 'Orders', 'Shop']
      const pathAllowed = routePath === '/' || routePath.startsWith('/Orders') || routePath.startsWith('/Shop')
      if (!allowWithoutLogin.includes(routeName) && !pathAllowed) {
        router.push({ name: 'Home' })
      }
    }

    if (response.data && response.data.Message === 'IS_LOGIN') {
      if (router.currentRoute.value.name === 'Home') router.push({ name: 'Home' })
    }

    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)

/* 首頁 */
export const getOnlineShops = () => APIService.get('/getOnlineShops') // 取得線上店家

/* 註冊、登入、驗證 */
export const isUserLogin = () => APIService.post('/isUserLogin')  // 消費者是否登入
export const UserRegister = (params) => APIService.post('/UserRegister', params)  // 註冊
export const UserLogin = (params) => APIService.post('/UserLogin', params) // 登入
export const isGuestLogin = () => APIService.post('/guest/isGuestLogin')  // 遊客是否登入（依 JWT 驗證）

/* 消費者 */
export const getUser = () => APIService.get('/User')  // 取得消費者
export const updateUser = (id, params) => APIService.put(`/User/${id}`, params) // 更新消費者
export const UserForgetPassword = (params) => APIService.post('/UserForgetPassword', params)  // 忘記密碼

/* 遊客 */
export const createGuest = (params) => APIService.post('/Guest', params)  // 建立遊客

/* 關注 */
export const getUserAttentions = () => APIService.get('/getUserAttentions')  // 取得消費者本人的關注列表
export const getUserAttention = (params) => APIService.post('/getUserAttention', params)
export const changeUserAttention = (params) => APIService.post('/changeUserAttention', params) // 更新關注

/* 店家 */
export const getShopByShopId = (id, params) => APIService.put(`/getShopByShopId/${id}`, params) // 取得店家資料

/* 訂單 */
export const getUserOrdersByLatestTen = () => APIService.get('/getUserOrdersByLatestTen')   // 取得最近十筆訂單
export const getUserOrder = (id) => APIService.get(`/getUserOrder/${id}`)   // 取得單筆訂單細節
export const createOrder = (params) => APIService.post('/Order', params)    // 建立訂單
export const getProductDetails = (params) => APIService.post('/getProductDetails', params)

/* 訂單，遊客 */
export const createOrderByGuest = (params) => APIService.post('/guest/Order', params)
export const getUserOrdersByLatestTenByGuest = (id) => APIService.get(`/guest/getUserOrdersByLatestTen/${id}`)   // 遊客取得最近十筆訂單
export const getUserOrderByGuest = (id) => APIService.get(`/guest/getUserOrder/${id}`)   // 遊客取得單筆訂單細節

/* 好康 */
export const getAdvertise = () => APIService.get('/Advertise') // 取得好康

/* 團購 */
export const getUserGroupbuies = () => APIService.get('/getUserGroupbuies')  // 取得團購列表

/* 簡訊 */
export const sendSMS = (params) => APIService.post('/sendSMS', params) // 發送簡訊

/* 系統 */
export const getUseTerm = (id = 1) => APIService.get(`/UseTerm/${id}`)  // 使用條款，遊客也可用
export const getDeclarations = (id) => APIService.get(`/getDeclarations/${id}`) // 購物車畫面，取得平台宣言及店家告示

/* LINE Pay */
export const LINEPayRequest = (params) => APIService.post('/LINEPayRequest', params) // LINE Pay API Request
export const LINEPayConfirm = (params) => APIService.post('/LINEPayConfirm', params) // LINE Pay API Confirm

/* LINE Notify */
export const LINENotifyHandleCallback = (params) => APIService.post('/LINENotify/handleCallback', params)    // LINE Notify Callback
export const LINENotifyCheckUserChoose = (params) => APIService.post('/LINENotify/checkUserChoose', params)  // LINE Notify 檢查使用者是否已正確選擇 Group

/* Socket（消費者問店家在線改由 Socket user:checkShop，不經此 API） */
export const GroupbuyEvent = (params) => APIService.post('/GroupbuyEvent', params)  // 發送團購訂單給主揪